import ReliabilityScore from '@/components/common/ReliabilityScore'
import { People, Person, UserIconFilled } from '@/components/icons'
import { LockedRating } from '@/components/profile-limit'
import { ROUTE_PLAYER_PROFILE } from '@/constants/Routes'
import { useRatingLock } from '@/hooks/useRatingLock'
import { ClubMemberRanking } from '@/types'
import { Link } from 'react-router-dom'

const RankingAvatar = ({ imageUrl }: { imageUrl?: string | null }) => {
  if (imageUrl) return <img src={imageUrl} className="rounded-full w-8 h-8" alt="avatar" />
  return <UserIconFilled className="w-8 h-8 text-primary-500" />
}

type RatingProps = {
  rating: string
  ratingType: string
  locked: boolean
}

const RankingRatingPill = ({ rating, ratingType, locked }: RatingProps) => {
  return (
    <div className="bg-navy-900/5 text-navy-900 rounded-lg px-2 w-12 h-9 flex flex-col justify-center items-center">
      {ratingType === 'doubles' ? <People /> : <Person />}
      <span className="text-xs text-navy-900 font-medium">{locked ? <LockedRating /> : rating}</span>
    </div>
  )
}

type Props = {
  member: ClubMemberRanking
  ratingType: string
}

export const ClubRankingItem = ({ member, ratingType }: Props) => {
  const isRatingLocked = useRatingLock()(member.id)
  return (
    <div className="flex items-center gap-4">
      <div className="w-8 h-8 rounded-full bg-white bg-opacity-70 flex items-center justify-center text-xl text-primary">
        {member.ranking}
      </div>
      <div className="flex flex-1 justify-between bg-white rounded-2xl p-4">
        <Link to={`${ROUTE_PLAYER_PROFILE}/${member.id}`} className={`flex gap-x-2 items-center`}>
          <RankingAvatar imageUrl={member.imageUrl} />
          <p className="text-navy-900 font-semibold">{member.fullName}</p>
        </Link>
        <div className="flex gap-x-1 items-center">
          <ReliabilityScore isWhiteBackground progress={member.reliability} />
          <RankingRatingPill rating={member.rating} ratingType={ratingType} locked={isRatingLocked} />
        </div>
      </div>
    </div>
  )
}
